import React from 'react';
import Card from 'material-ui/Card';

class DescriptorList extends React.Component {
  render() {

    if (this.props.descriptors) {
      const descriptors = this.props.descriptors.map((descriptor) =>
        <Card>
          <div>
          <div>{descriptor.name}</div>
          <div dangerouslySetInnerHTML={{ __html: descriptor.description }}></div>
          </div>
        </Card>
      );

      return (
      <ul>
        {descriptors}
      </ul>
      );
    } else {
      return (
        <div></div>
      )
    }
    
  }
}

export default DescriptorList;


// WEBPACK FOOTER //
// ./src/components/DescriptorList.js